/**
 * @generated SignedSource<<67e071a33cf45c408e850b759f06d544>>
 * @relayHash 2dcb74ffdda96ee8a118627d99d348d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainProjectNameQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type mainProjectNameQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly __typename: "JiraProject";
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type mainProjectNameQuery = {
  response: mainProjectNameQuery$data;
  variables: mainProjectNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainProjectNameQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainProjectNameQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19",
    "metadata": {},
    "name": "mainProjectNameQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fca14514ec7cc9e866219e1ef4f3f1e9";

export default node;
